import React from "react";

import { DeleteWithDependenciesModal } from "src/agents/modals/DeleteWithDependenciesModal";
import { AgentVersion } from "src/agents/types";
import {
  useDraftFlowsReferencingAgentVersion,
  usePublishedFlowsReferencingAgentVersion,
} from "src/api/agents/flowReferences";

type DeleteAgentVersionModalProps = {
  isOpen: boolean;
  version: AgentVersion | undefined;
  workspaceId: string;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
};

export const DeleteAgentVersionModal: React.FC<
  DeleteAgentVersionModalProps
> = ({ isOpen, version, workspaceId, onClose, onConfirm }) => {
  const queryEnabled = isOpen && !!version;

  const { data: publishedFlows, isLoading: isLoadingPublished } =
    usePublishedFlowsReferencingAgentVersion(
      workspaceId,
      version?.agent_id ?? "",
      version?.id ?? "",
      { enabled: queryEnabled },
    );
  const { data: draftFlows, isLoading: isLoadingDraft } =
    useDraftFlowsReferencingAgentVersion(
      workspaceId,
      version?.agent_id ?? "",
      version?.id ?? "",
      { enabled: queryEnabled },
    );

  return (
    <DeleteWithDependenciesModal
      blockingDescription="This version cannot be deleted because it is used by published versions of other resources:"
      blockingMessage="Please remove these connections before deleting this version."
      blockingTitle={`Cannot delete version "${version?.name}"`}
      confirmationDataLoc="delete-agent-version-confirmation"
      confirmationDescription="Are you sure you want to delete this version? This action cannot be undone."
      confirmationTitle={`Delete version "${version?.name}"`}
      draftFlows={draftFlows}
      draftWarningMessage="Deleting this version may break the connections listed below:"
      isLoading={isLoadingPublished || isLoadingDraft}
      isOpen={isOpen}
      publishedFlows={publishedFlows}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
